import React from "react";
import { Transition, Container, Segment, Header } from "semantic-ui-react";
import Buscadores from "./escuelas/Buscadores";

class Escuelas extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState(state => ({ visible: true }));
  }

  componentWillUnmount() {
    this.setState(state => ({ visible: false }));
  }

  render() {
    return (
      <Container>
        <Segment basic padded textAlign="center">
          <Transition.Group animation="scale" duration={150}>
            {this.state.visible && (
              <Header inverted as="h1">
                ExtraGestor Escuelas de Primavera
              </Header>
            )}
          </Transition.Group>

          <Segment basic>
            <Buscadores visible={this.state.visible} />
          </Segment>
        </Segment>
      </Container>
    );
  }
}
export default Escuelas;



// WEBPACK FOOTER //
// ./src/pages/Escuelas.jsx